/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "common": {
                            "nested": {
                              "Signature": {
                                "fields": {
                                  "collectSignature": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "showReceiptScreen": {
                                    "type": "bool",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "signaturePreference": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.SignaturePreference",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": "DIGITAL"
                                    }
                                  },
                                  "paperSignatureSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.PaperSignatureSettings",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "digitalSignatureSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.DigitalSignatureSettings",
                                    "id": 5,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "PaperSignatureSettings": {
                                "fields": {
                                  "tipType": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.PaperSignatureSettings.TipType",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": "QUICK_TIP"
                                    }
                                  },
                                  "printCustomerCopy": {
                                    "type": "bool",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "includeItemDetails": {
                                    "type": "bool",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "printAdditionalAuthSlip": {
                                    "type": "bool",
                                    "id": 4,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  }
                                },
                                "nested": {
                                  "TipType": {
                                    "values": {
                                      "UNKNOWN": 0,
                                      "TRADITIONAL": 1,
                                      "QUICK_TIP": 2,
                                      "GRATUITY_FREE": 3
                                    }
                                  }
                                }
                              },
                              "DigitalSignatureSettings": {
                                "fields": {
                                  "condition": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.DigitalSignatureSettings.CollectSignatureCondition",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": "ALL_PURCHASES"
                                    }
                                  }
                                },
                                "nested": {
                                  "CollectSignatureCondition": {
                                    "values": {
                                      "UNKNOWN": 0,
                                      "PURCHASES_OVER_THRESHOLD": 1,
                                      "ALL_PURCHASES": 2
                                    }
                                  }
                                }
                              },
                              "SignaturePreference": {
                                "values": {
                                  "UNKNOWN": 0,
                                  "DIGITAL": 1,
                                  "PAPER": 2
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.Signature && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.PaperSignatureSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.PaperSignatureSettings?.nested?.TipType && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.DigitalSignatureSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.DigitalSignatureSettings?.nested?.CollectSignatureCondition && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.SignaturePreference) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE Signature @ squareup/devicesettings/profiles/v2/model/settings/common/signature.proto at 16:1
 */
export const Signature = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.Signature');
fixType(Signature);
Builder.createAndAttachToType(Signature);
/**
 * SOURCE PaperSignatureSettings @ squareup/devicesettings/profiles/v2/model/settings/common/signature.proto at 24:1
 */
export const PaperSignatureSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.PaperSignatureSettings');
fixType(PaperSignatureSettings);
Builder.createAndAttachToType(PaperSignatureSettings);
/**
 * SOURCE TipType @ squareup/devicesettings/profiles/v2/model/settings/common/signature.proto at 28:3
 */
PaperSignatureSettings.TipType = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.common.PaperSignatureSettings.TipType').values;
/**
 * SOURCE DigitalSignatureSettings @ squareup/devicesettings/profiles/v2/model/settings/common/signature.proto at 37:1
 */
export const DigitalSignatureSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.DigitalSignatureSettings');
fixType(DigitalSignatureSettings);
Builder.createAndAttachToType(DigitalSignatureSettings);
/**
 * SOURCE CollectSignatureCondition @ squareup/devicesettings/profiles/v2/model/settings/common/signature.proto at 39:3
 */
DigitalSignatureSettings.CollectSignatureCondition = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.common.DigitalSignatureSettings.CollectSignatureCondition').values;
/**
 * SOURCE SignaturePreference @ squareup/devicesettings/profiles/v2/model/settings/common/signature.proto at 46:1
 */
export const SignaturePreference = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.common.SignaturePreference').values;